import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(localizedFormat);

const DATE_FMT = 'L LTS';
export const formatDateTime = (v?: string) => (v ? dayjs(v).format(DATE_FMT) : '');
export const generatePassword = () => Math.random().toString(36).slice(-32);
